import _range from 'lodash/range'

import { createAsyncTypes } from 'utils/ActionCreator'

export const INCIDENT_RESPONSE_REQUEST_ASYNC = createAsyncTypes(
  'INCIDENT_RESPONSE_REQUEST',
  'Settings/IncidentResponse/ShowIncidentResponse'
)
export const SUBMIT_INCIDENT_RESPONSE_ASYNC = createAsyncTypes(
  'SUBMIT_INCIDENT_RESPONSE',
  'Settings/IncidentResponse/ShowIncidentResponse'
)

export const UPDATE_SETTINGS_FIELD =
  'Settings/IncidentResponse/ShowIncidentResponse/UPDATE_SETTINGS_FIELD'
export const UPDATE_DEEP_SETTINGS_FIELD =
  'Settings/IncidentResponse/ShowIncidentResponse/UPDATE_DEEP_SETTINGS_FIELD'

export const attackThresholdOptions = _range(1, 21).map((v) => ({
  value: v,
  label: `${v} pts`,
}))
export const markAsSpamActionOptions = [
  { value: 10, label: 'Do nothing' },
  { value: 2, label: 'Move to spam folder' },
  { value: 1, label: 'Move to quarantine' },
]

export const DATE_FILTERS_OPTIONS = [
  { value: 9, label: '30 days' },
  { value: 10, label: '90 days' },
  { value: 11, label: 'All times' },
  { value: 15, label: 'Custom Range' },
]

export const ATTACK_ACTION_TYPES_CONST = [
  { value: 3, label: 'Send Inline Message' },
  { value: 1, label: 'Quarantine Phishing Email' },
  { value: 2, label: 'Move Phishing Email To Spam' },
]

export const UNVERIFIED_ATTACK_ACTION_TYPES_CONST = [
  ...ATTACK_ACTION_TYPES_CONST,
  { value: 10, label: 'Do nothing' },
]

export const ATO_SENSITIVITY_TOOLTIP_TEXTS = {
  1: 'Aggressive sensitivity for detecting suspicious account activities. Recommended for highly sensitive environments.',
  2: 'Balanced monitoring of suspicious activities, with a focus on high-probability risks. Ideal for most environments.',
  3: 'Relaxed sensitivity, focusing only on the most severe indicators of suspicious behavior. Suitable for low-risk environments.',
}

export const SPAM_SENSITIVITY_LEVELS = {
  AGGRESSIVE: 1,
  BALANCED: 2,
  RELAXED: 3,
}

export const SPAM_SENSITIVITY_TOOLTIP_TEXTS = {
  [SPAM_SENSITIVITY_LEVELS.RELAXED]:
    'Allows more emails through, flagging only highly suspicious spam to minimize disruptions.',
  [SPAM_SENSITIVITY_LEVELS.BALANCED]:
    'The recommended setting, providing effective spam detection while maintaining accuracy.',
  [SPAM_SENSITIVITY_LEVELS.AGGRESSIVE]:
    'Applies strict filtering, blocking even borderline spam, which may occasionally affect legitimate emails.',
}

export const UNVERIFIED_ACTION = 'unverified'
